import { render, staticRenderFns } from "./ImportExport.vue?vue&type=template&id=8b45a44c&scoped=true"
import script from "./ImportExport.vue?vue&type=script&lang=js"
export * from "./ImportExport.vue?vue&type=script&lang=js"
import style0 from "./ImportExport.vue?vue&type=style&index=0&id=8b45a44c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b45a44c",
  null
  
)

export default component.exports